// src/Components/Modules/Inventory/ProductBatches.js
import React, { useState, useEffect } from 'react';
import { AxiosAuthInstance } from '../../../AxiosInterceptors';
import Breadcrumb from '../../Partials/Breadcrumb';
import {
    Box, Typography, Paper, Button, TextField, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, Dialog, DialogTitle, DialogContent,
    DialogActions, Chip, FormControl, InputLabel, Select, MenuItem
} from '@mui/material';
import { FaPlus } from 'react-icons/fa';
import Swal from 'sweetalert2';

export default function ProductBatches() {
    const [batches, setBatches] = useState([]);
    const [items, setItems] = useState([]);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [form, setForm] = useState({ item_id: '', batch_number: '', serial_number: '', expiry_date: '', quantity: '' });

    const fetchData = async () => {
        const [bRes, iRes] = await Promise.all([
            AxiosAuthInstance.get('product-batches'),
            AxiosAuthInstance.get('item_list') // Adjust if your item endpoint is different
        ]);
        setBatches(bRes.data.batches || []);
        setItems(iRes.data.items || iRes.data || []);
    };

    useEffect(() => { fetchData(); }, []);

    const handleSave = async () => {
        try {
            await AxiosAuthInstance.post('product-batches', form);
            Swal.fire({ icon: 'success', title: 'Batch Added!', timer: 1500, showConfirmButton: false });
            setDialogOpen(false);
            setForm({ item_id: '', batch_number: '', serial_number: '', expiry_date: '', quantity: '' });
            fetchData();
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Error', text: err.response?.data?.message || 'Failed' });
        }
    };

    return (
        <Box sx={{ p: 3, bgcolor: '#f5f7fa', minHeight: '100vh' }}>
            <Breadcrumb title="Batch / Serial Tracking" />
            <Paper sx={{ p: 3, mb: 3, display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h5" fontWeight={700}>Product Batches & Serial Numbers</Typography>
                <Button variant="contained" startIcon={<FaPlus />} onClick={() => setDialogOpen(true)}>Add Batch</Button>
            </Paper>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ bgcolor: '#f8f9fa' }}>
                            <TableCell>Batch Number</TableCell>
                            <TableCell>Serial Number</TableCell>
                            <TableCell>Item Name</TableCell>
                            <TableCell>Expiry Date</TableCell>
                            <TableCell align="right">Quantity</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {batches.map((b) => (
                            <TableRow key={b.id} hover>
                                <TableCell><code>{b.batch_number || '-'}</code></TableCell>
                                <TableCell><code>{b.serial_number || '-'}</code></TableCell>
                                <TableCell>{b.item?.name || 'Item'}</TableCell>
                                <TableCell>
                                    {b.expiry_date ? (
                                        <Chip label={b.expiry_date} size="small" color="warning" />
                                    ) : '-'}
                                </TableCell>
                                <TableCell align="right">{Number(b.quantity).toLocaleString()}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Add New Batch / Serial</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        <FormControl fullWidth size="small">
                            <InputLabel>Item</InputLabel>
                            <Select value={form.item_id} label="Item" onChange={(e) => setForm({...form, item_id: e.target.value})}>
                                <MenuItem value="">Select Item</MenuItem>
                                {items.map(i => <MenuItem key={i.id} value={i.id}>{i.name}</MenuItem>)}
                            </Select>
                        </FormControl>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <TextField label="Batch Number" size="small" value={form.batch_number} onChange={(e) => setForm({...form, batch_number: e.target.value})} fullWidth />
                            <TextField label="Serial Number" size="small" value={form.serial_number} onChange={(e) => setForm({...form, serial_number: e.target.value})} fullWidth />
                        </Box>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <TextField label="Expiry Date" type="date" size="small" value={form.expiry_date} onChange={(e) => setForm({...form, expiry_date: e.target.value})} fullWidth InputLabelProps={{shrink: true}} />
                            <TextField label="Quantity" type="number" size="small" value={form.quantity} onChange={(e) => setForm({...form, quantity: e.target.value})} fullWidth />
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
                    <Button variant="contained" onClick={handleSave}>Save Batch</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}